module.exports = __webpack_public_path__ + "img/demoliciones.4bfd13f8.png";